import { PixelateVariantProps } from 'common/Prose/nodeViews/Image/components/ImageVariant/Types'
import { ImageVariant } from 'common/Prose/nodeViews/Image/components/ImageVariant/ImageVariant'
import { useImageStore } from 'stores/ImageStore'
import { useCloudinary } from 'providers/CloudinaryProvider/CloudinaryProvider'
import { pixelate } from '@cloudinary/url-gen/actions/effect'
import { SliderField } from './SliderField'

export const PixelateVariant = (props: PixelateVariantProps) => {
  const { variant } = props
  const imageStore = useImageStore()
  const cloudinary = useCloudinary()

  if (!cloudinary) return null

  return (
    <ImageVariant {...props}>
      <SliderField
        minValue={1}
        maxValue={200}
        step={1}
        initialValue={variant.qualifier ?? 30}
        label="Change pixel size"
        onChangeEnd={(value) => {
          const image = cloudinary.image(variant.sourceUrl.split('?')[0]).setDeliveryType('fetch')
          image.effect(pixelate(value))
          imageStore.clearVariants()
          imageStore.createVariant({ image, url: image.toURL(), action: 'pixelate', qualifier: value })
        }}
      />
    </ImageVariant>
  )
}
